'use strict';

/**
 * Base class for a CollectionView
 *
 * @category   View
 * @module     base
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Marionette = require('backbone-marionette');
var sortViewExtension = require('base/mixins/sort-view');

var CollectionView = Marionette.CollectionView.extend({
    constructor: function() {
        Marionette.CollectionView.prototype.constructor.apply(this, arguments);

        this.listenTo(App.vent, 'resizeThrottled', function() { this.triggerMethod('resize'); }.bind(this));
    },

    initialize: function(options) {
        // Apply sort if sort extension is available
        if (_.isString(this.getOption('sortDefault'))
            && this.getOption('sortDefault').length > 0
            && _.isFunction(this.sortByFields)
        ) {
            this.sortByFields(this.getOption('sortDefault'));
        }
    },
});

// Apply Mixins
_.extend(CollectionView.prototype, sortViewExtension);

module.exports = CollectionView;